import React, { createContext, useState, useContext } from "react";

const ProjectContext = createContext();

export const useProjects = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    console.warn("useProjects used outside ProjectProvider — using fallback no-op implementation");
    return {
      projects: [],
      setProjects: () => {},
      addProject: () => {},
      updateProject: () => {},
      deleteProject: () => {},
      getProjectById: () => null,
    };
  }
  return context;
};

export const ProjectProvider = ({ children }) => {
  const [projects, setProjects] = useState([
    {
      id: "PRO-001",
      title: "Office Management",
      name: "Office Management App",
      desc: "An office management app project streamlines administrative tasks...",
      user: "Anthony Lewis",
      leader: "Anthony Lewis",
      role: "Project Leader",
      deadline: "14 Jan 2024",
      date: "14 Jan 2024",
      tasks: "6/10",
      img: "/assets/img/users/user-39.jpg",
      priority: "High",
      status: "Active",
      client: "ABC Corp",
      startDate: "2024-01-01",
      endDate: "2024-01-14",
      projectValue: "$10000",
      priceType: "Fixed",
      description:
        "An office management app project streamlines administrative tasks...",
      members: ["Anthony Lewis"],
      teamLeader: "Anthony Lewis",
      projectManager: "Anthony Lewis",
      tags: [],
      image: "/assets/img/users/user-39.jpg",
    },
    {
      id: "PRO-002",
      title: "Clinic Management",
      name: "Clinic Management",
      desc: "A clinic management project streamlines patient records...",
      user: "Sophie Headrick",
      leader: "Sophie Headrick",
      role: "Project Leader",
      deadline: "15 Jan 2024",
      date: "15 Jan 2024",
      tasks: "7/10",
      img: "/assets/img/users/user-40.jpg",
      priority: "Medium",
      status: "Active",
      client: "XYZ Healthcare",
      startDate: "2024-01-05",
      endDate: "2024-01-15",
      projectValue: "$15000",
      priceType: "Hourly",
      description: "A clinic management project streamlines patient records...",
      members: ["Sophie Headrick"],
      teamLeader: "Sophie Headrick",
      projectManager: "Sophie Headrick",
      tags: [],
      image: "/assets/img/users/user-40.jpg",
    },
     {
      id: "PRO-001",
      title: "Office Management",
      name: "Office Management App",
      desc: "An office management app project streamlines administrative tasks...",
      user: "Anthony Lewis",
      leader: "Anthony Lewis",
      role: "Project Leader",
      deadline: "14 Jan 2024",
      date: "14 Jan 2024",
      tasks: "6/10",
      img: "/assets/img/users/user-39.jpg",
      priority: "High",
      status: "Active",
      client: "ABC Corp",
      startDate: "2024-01-01",
      endDate: "2024-01-14",
      projectValue: "$10000",
      priceType: "Fixed",
      description:
        "An office management app project streamlines administrative tasks...",
      members: ["Anthony Lewis"],
      teamLeader: "Anthony Lewis",
      projectManager: "Anthony Lewis",
      tags: [],
      image: "/assets/img/users/user-39.jpg",
    },
     {
      id: "PRO-001",
      title: "Office Management",
      name: "Office Management App",
      desc: "An office management app project streamlines administrative tasks...",
      user: "Anthony Lewis",
      leader: "Anthony Lewis",
      role: "Project Leader",
      deadline: "14 Jan 2024",
      date: "14 Jan 2024",
      tasks: "6/10",
      img: "/assets/img/users/user-39.jpg",
      priority: "High",
      status: "Active",
      client: "ABC Corp",
      startDate: "2024-01-01",
      endDate: "2024-01-14",
      projectValue: "$10000",
      priceType: "Fixed",
      description:
        "An office management app project streamlines administrative tasks...",
      members: ["Anthony Lewis"],
      teamLeader: "Anthony Lewis",
      projectManager: "Anthony Lewis",
      tags: [],
      image: "/assets/img/users/user-39.jpg",
    },
     {
      id: "PRO-001",
      title: "Office Management",
      name: "Office Management App",
      desc: "An office management app project streamlines administrative tasks...",
      user: "Anthony Lewis",
      leader: "Anthony Lewis",
      role: "Project Leader",
      deadline: "14 Jan 2024",
      date: "14 Jan 2024",
      tasks: "6/10",
      img: "/assets/img/users/user-39.jpg",
      priority: "High",
      status: "Active",
      client: "ABC Corp",
      startDate: "2024-01-01",
      endDate: "2024-01-14",
      projectValue: "$10000",
      priceType: "Fixed",
      description:
        "An office management app project streamlines administrative tasks...",
      members: ["Anthony Lewis"],
      teamLeader: "Anthony Lewis",
      projectManager: "Anthony Lewis",
      tags: [],
      image: "/assets/img/users/user-39.jpg",
    },
  ]);

  // Add new project
  const addProject = (newProject) => {
    const id = `PRO-${String(projects.length + 1).padStart(3, "0")}`;
    const projectToAdd = {
      id,
      ...newProject,
      name: newProject.title, // For list view compatibility
    };
    setProjects([...projects, projectToAdd]);
  };

  // Update existing project
  const updateProject = (id, updatedProject) => {
    setProjects(
      projects.map((proj) =>
        proj.id === id ? { ...proj, ...updatedProject } : proj,
      ),
    );
  };

  // Delete project
  const deleteProject = (id) => {
    setProjects(projects.filter((proj) => proj.id !== id));
  };

  // Get project by ID
  const getProjectById = (id) => {
    return projects.find((proj) => proj.id === id);
  };

  const value = {
    projects,
    setProjects,
    addProject,
    updateProject,
    deleteProject,
    getProjectById,
  };

  return (
    <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>
  );
};
